import * as actions from './designationMaster/actions'
import * as mutations from './designationMaster/mutations'
import * as getters from './designationMaster/getters'

import { dataProps } from './designationMaster/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/designationMaster.js